export enum PersonType {
  Contact = 'CONTACT',
  User = 'USER',
  All = 'ALL',
}

export interface UserAndContact {
  id?: number;
  name: string;
  priority?: number;
  functionName?: string | null;
  phone?: string | null;
  additionalPhone?: string | null;
  type?: PersonType;
  allPartitions?: boolean;
  codeAllPartitions?: number | null;
  nextel?: string | null;
  email?: string | null;
  observation?: string | null;
  function?: PersonFunction | null;
  list?: number;
  partitions?: PersonPartition[];
  contactsReason: {
    fire: ContactReasonItem;
    violation: ContactReasonItem;
    medical: ContactReasonItem;
    panic: ContactReasonItem;
  };
  questionPassword?: string | null;
  answerPassword?: string | null;
  answerCoercion?: string | null;
  taxpayerIdentification?: string | null;
  identificationNumber?: string | null;
}

export interface PersonFunction {
  enabled: boolean;
  name: string;
  id: number;
}

export interface PersonPartition {
  partition: string;
  partitionId: number;
}

export enum ContactReasonItemIcon {
  Fire = 'Fire',
  Violation = 'Violation',
  Medical = 'Medical',
  Panic = 'Panic',
}

export enum ContactReasonItemText {
  Fire = 'fire',
  Violation = 'violation',
  Medical = 'medical',
  Panic = 'panic',
}

export interface ContactReasonItem {
  color: string;
  enabled: boolean;
  icon: ContactReasonItemIcon;
  id: number;
  text: ContactReasonItemText;
}
